module.exports = function(){

    /**
    * Audit log
    */
    if (document.querySelector('#datatable-all-audit-log')) {
        require('./audit/audit-log');
    }

	/**
     * Bank Accounts
     */
	if(document.querySelector('#datatable-bank-accounts')) {
		require('./bank_accounts/index.js');
	}

    /**
     * Blocks
     */
    if(document.querySelector('#datatable-all-blocks-of-client')) {
        require('./blocks/of-client.js');
    }

	/**
	 * Client Contacts
	 */
	if(document.querySelector('#datatable-all-client-contacts')) {
		require('./client_contacts/all.js');
	}

    /**
     * Clients
     */
    if(document.querySelector('#datatable-all-clients')) {
        require('./clients/index-table.js');
    }

    if(document.querySelector('#datatable-all-properties-of-client')) {
        require('./clients/properties-of-client.js');
    }

    /**
     * Contractors
     */
    if(document.querySelector('#datatable-all-contractors')) {
        require('./contractors/index-table.js');
    }

    /**
     * Contractor Contacts
     */
	if(document.querySelector('#datatable-all-contractor-contacts')) {
		require('./contractor_contacts/all.js');
	}

	/**
     * Departments
     */
	if(document.querySelector('#datatable-departments')) {
		require('./departments/index.js');
	}

    /**
     * Documents
     */
	if(document.querySelector('#datatable-all-certificates-of-client')) {
		require('./documents/certificates-of-client.js');
	}

	if(document.querySelector('#datatable-all-certificates')) {
		require('./documents/all-certificates.js');
	}

    if(document.querySelector('#datatable-all-certificates-of-block')) {
        require('./documents/certificates-of-block.js');
    }

    /**
     * EmploymentHistory
     */
    if(document.querySelector('.datatable-employment-history-of-guardian')) {
        require('./guardians/employment-history-of-guardian.js');
    }

	/**
	* Expenditures
	*/

	if (document.querySelector('#datatable-all-property-expenditures-items')) {
		require('./expenditures/expenditures-items-of-property');
	}

	if (document.querySelector('#datatable-all-expenditures-items')) {
		require('./expenditures/expenditures');
	}

	if(document.querySelector('#datatable-expense-account')) {
		require('./expenditures/expense_account.js');
	}

    /**
     * Guardians
     */

    if(document.querySelector('#datatable-all-guardians')) {
        require('./guardians/all.js');
    }

    if(document.querySelector('#datatable-all-guardians-client-side')) {
        require('./guardians/index-table-client-side.js');
    }

    if(document.querySelector('#datatable-guardians-after-deadline')) {
        require('./guardians/after-deadline.js');
    }

    if(document.querySelector('#datatable-guardians-paid')) {
        require('./guardians/paid.js');
    }

	/**
     * Inspection Routes
     */
	if(document.querySelector('#datatable-inspection-routes')) {
		require('./inspection_routes/index.js');
	}

	/**
     * Inspection Types
     */
	if(document.querySelector('#datatable-inspection-types')) {
		require('./inspection_types/index.js');
	}

	/**
     * Inspections
     */
	if(document.querySelector('#datatable-inspections')) {
		require('./inspections/index.js');
	}

	/**
     * Lead Sources
     */
	if(document.querySelector('#datatable-lead-sources')) {
		require('./lead_sources/index.js');
	}

	/**
     * Market Segments
     */
	if(document.querySelector('#datatable-market-segments')) {
		require('./market_segments/index.js');
	}

    /**
     * Payments
     */
    if(document.querySelector('#datatable-rent-payments')) {
        require('./payments/of-rent.js');
    }

    if(document.querySelector('#datatable-guardians-payments')) {
        require('./payments/of-guardian.js');
    }

    if(document.querySelector('#datatable-guardians-payments-initial')) {
        require('./payments/of-guardian-initial.js');
    }

    if(document.querySelector('.datatable-guardians-initial-simple')) {
        require('./payments/of-guardian-initial-simple.js');
    }

    if(document.querySelector('#datatable-guardians-payments-key-fee')) {
        require('./payments/of-guardian-key-fee.js');
    }

    if(document.querySelector('.datatable-guardians-key-fee-simple')) {
        require('./payments/of-guardian-key-fee-simple.js');
    }

	if(document.querySelector('#datatable-payments-without-due-date')) {
		require('./payments/without-due-date.js');
	}

    /**
     * Permissions
     */
    if(document.querySelector('#datatable-all-permissions')) {
        require('./permissions/index-table.js');
    }

    /**
     * Profit & Loss
     */
    if(document.querySelector('#datatable-profit-and-loss')) {
        require('./profit_and_loss/index.js');
    }

    /**
     * Properties
     */
    if(document.querySelector('#datatable-all-properties')) {
        require('./properties/index-table.js');
    }

	if(document.querySelector('#datatable-all-properties-read-only')) {
		require('./properties/for-contractor-read-only.js');
	}

    if(document.querySelector('#datatable-all-rooms-search')) {
        require('./properties/rooms-search.js');
    }

    if(document.querySelector('#datatable-properties-with-vacant-rooms')) {
        require('./properties/vacant_rooms.js');
    }

    if(document.querySelector('#datatable-all-properties-of-block')) {
        require('./properties/of-block.js');
    }

	if(document.querySelector('#datatable-all-properties-of-inspection-route')) {
		require('./properties/of-inspection-route.js');
	}

	if(document.querySelector('#datatable-properties-monthly-inspections')) {
		require('./properties/monthly-inspections.js');
	}

    if(document.querySelector('.datatable-property-notes')) {
    
		require('./properties/notes.js');
	}


    /**
    * Property Notice To Quit
    */

	if(document.querySelector('#datatable-all-property-notice-to-quit')) {
		require('./property_notice_to_quit/index-table.js');
	}

    /**
     * Property Viewings
     */
    if(document.querySelector('#datatable-property-viewings')) {
        require('./property_viewings/index-table.js');
    }

    if(document.querySelector('#datatable-property-viewings-access-tab')) {
        require('./property_viewings/access-table.js');
    }

    if(document.querySelector('#datatable-property-viewing-report')) {
        require('./property_viewings/report.js');
    }

    if(document.querySelector('#datatable-my-confirmations')) {
        require('./property_viewings/my_confirmations.js');
    }

	if(document.querySelector('#datatable-keep-me-informed')) {
		require('./property_viewings/keep_me_informed.js');
	}

    /**
     * Rents
     */

    if(document.querySelector('#datatable-all-rents')) {
        require('./rents/index-table.js');
    }

    if(document.querySelector('#datatable-guardian-history')) {
        require('./rents/history.js');
    }

    if(document.querySelector('#datatable-payments-active')) {
        require('./rents/activePayments.js');
    }

    if(document.querySelector('#datatable-property-payment-list')) {
        require('./rents/paymentListOfProperty.js');
    }

    if(document.querySelector('#datatable-rents-after-date-end')) {
        require('./rents/after-date-end.js');
    }

	/**
	 * Rent Notice To Quit
	 */

	if(document.querySelector('#datatable-all-rent-notice-to-quit')) {
		require('./rent_notice_to_quit/index-table.js');
	}

    /**
     * Guardian Queries
     */

    if(document.querySelector('#datatable-all-guardian-queries')) {
        require('./guardian-queries/index-table.js');
    }

    if(document.querySelector('#datatable-all-guardian-queries-of-guardian')) {
        require('./guardian-queries/of-guardian.js');
    }

    /**
     * Tickets
     */
    if(document.querySelector('#datatable-all-tickets')) {
        require('./tickets/index-table.js');
    }

    if(document.querySelector('#datatable-all-complaints')) {
        require('./tickets/complaints.js');
    }

    if(document.querySelector('#datatable-all-tickets-search-dates')) {
        require('./tickets/index-table-search-dates.js');
    }

    if(document.querySelector('#datatable-all-tickets-of-property')) {
        require('./tickets/tickets-of-property.js');
    }

    if(document.querySelector('#datatable-all-tickets-of-property-for-mir')) {
        require('./tickets/tickets-for-monthly-inspection-report.js');
    }

    if(document.querySelector('#datatable-all-tickets-of-property-for-mir-pp')) {
        require('./tickets/tickets-for-monthly-inspection-report-property-summary.js');
    }

    if(document.querySelector('#datatable-all-tickets-of-contractor')) {
        require('./tickets/tickets-of-contractor.js');
    }
    if(document.querySelector('#datatable-all-tickets-of-guardian')) {
        require('./tickets/tickets-of-guardian.js');
    }

    if(document.querySelector('#datatable-all-tickets-of-guardian-search-dates')) {
        require('./tickets/tickets-of-guardian-search-dates.js');
    }

	if(document.querySelector('#datatable-tickets-of-client')) {
		require('./tickets/of-client.js');
	}

	if(document.querySelector('#datatable-tickets-cost-of-works-of-client')) {
		require('./tickets/cost-of-works-of-client.js');
	}

	/**
	* Users
	*/
	if(document.querySelector('#datatable-all-users')) {
		require('./users/index-table.js');
	}

	if(document.querySelector('#datatable-all-staff')) {
		require('./users/staff.js');
	}

    /**
     * VIP
     */
    // if(document.querySelector('#datatable-vip-of-client')) {
    //     require('./vip/of-client.js');
    // }

    if(document.querySelector('#datatable-client-all-blocks-vip')) {
        require('./vip/of-client-all.js');
    }

    if(document.querySelector('#datatable-block-vip')) {
        require('./vip/of-block.js');
    }

    if (document.querySelector('#datatable-petty-cash')) {
        require('./petty_cash/index.js')
    }

    if (document.querySelector('#datatable-rooms-with-couples')) {
        require('./rooms/couples.js')
    }
}();
